
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import TableScrollWrapper from '@/common/components/UI/TableScrollWrapper/index.vue'
import TheTable from '@/common/components/UI/TheTable/index.vue'

// module components
import PVZForm from '@/modules/PVZModule/components/PVZForm/index.vue'
import PVZAddUser from '@/modules/PVZModule/components/PVZAddUser/index.vue'
import PVZUploadPhoto from '@/modules/PVZModule/components/PVZUploadPhoto/index.vue'
import PVZFilters from '@/modules/PVZModule/components/PVZFilters/index.vue'
import PVZTableActionsButton from '@/modules/PVZModule/components/PVZTableActionsButton/index.vue'

// types
import { PVZT } from '@/core/types/pvz.types'

// realisations
import { pvz } from '@/core/realisations/pvz.realisation'

// classes
import { DataState } from '@/core/classes/DataState.class'

// constants
import { PVZColumns } from '@/core/constants/columns/PVZ.columns'

export default defineComponent({
    components: {
        'page-title': PageTitle,
        'the-button': TheButton,
        'failed-fetch': FailedFetch,
        'pvz-form': PVZForm,
        'pvz-add-user': PVZAddUser,
        'pvz-upload-photo': PVZUploadPhoto,
        'pvz-filters': PVZFilters,
        TableScrollWrapper,
        TheTable,
        'pvz-table-actions-button': PVZTableActionsButton,
    },
    setup() {
        const state = reactive({
            pvz: new DataState<PVZT>({}),
            is_loading: false,
        })

        const form_state = reactive({
            is_update: false,
            is_create: false,
            is_visible: false,
            is_add_user: false,
            initial_value: null as PVZT | null,
        })

        const user_state = reactive({
            opened: false,
            pvz_id: null as number | null,
        })

        const upload_state = reactive({
            opened: false,
            pvz_id: null as number | null,
            pvz_name: null as string | null,
        })

        const filters_state = reactive({
            invoice_number: undefined as string | undefined,
            name: undefined as string | undefined,
            cityId: undefined as string | undefined,
        })

        const loadPVZ = async (page: number) => {
            state.pvz.pagination.current_page = page

            const params = {
                page,
                name: filters_state.name,
                cityId: filters_state.cityId,
            }

            try {
                state.pvz.is_loading = true
                const response = await pvz.getList(params)

                state.pvz.list = response.data
                state.pvz.pagination.total_pages = response.meta.last_page

                state.pvz.is_failed = false
                state.pvz.failure.error_state.is_cancel = false
            } catch (error) {
                state.pvz.failure.catchError(error)

                if (!state.pvz.failure.error_state.is_cancel) {
                    state.pvz.is_failed = true
                }
            } finally {
                if (!state.pvz.failure.error_state.is_cancel) {
                    state.pvz.is_loading = false
                }
            }
        }

        const onUpdatePVZ = (pvz: PVZT) => {
            form_state.is_add_user = false
            form_state.is_update = true
            form_state.is_create = false

            form_state.initial_value = pvz
            form_state.is_visible = true
        }

        const onAddUser = (pvz: PVZT) => {
            user_state.opened = true
            user_state.pvz_id = pvz.id
        }

        const onCancelAddUser = () => {
            user_state.opened = false
            user_state.pvz_id = null
        }

        const onAddPVZ = () => {
            form_state.is_add_user = false
            form_state.is_update = false
            form_state.is_create = true

            form_state.initial_value = null
            form_state.is_visible = true
        }

        const closePVZForm = () => {
            form_state.is_visible = false
            loadPVZ(state.pvz.pagination.current_page)
        }

        onBeforeMount(() => {
            loadPVZ(1)
        })

        const startUpload = ({ pvz_id, pvz_name }: { pvz_id: number; pvz_name: string }) => {
            upload_state.pvz_id = pvz_id
            upload_state.pvz_name = pvz_name
            upload_state.opened = true
        }

        const cancelUpload = () => {
            upload_state.opened = false
            upload_state.pvz_id = null
            upload_state.pvz_name = null
        }

        const onSearch = (filters: { name: string; cityId: string }) => {
            filters_state.name = filters.name
            filters_state.cityId = filters.cityId

            loadPVZ(1)
        }

        const onReset = () => {
            filters_state.name = undefined
            filters_state.cityId = undefined

            loadPVZ(1)
        }

        return {
            state,
            form_state,
            filters_state,
            user_state,
            upload_state,
            loadPVZ,
            onUpdatePVZ,
            onAddUser,
            onCancelAddUser,
            onAddPVZ,
            closePVZForm,
            startUpload,
            cancelUpload,
            onSearch,
            onReset,
            //
            PVZColumns,
        }
    },
})
